import { 
    NEWSLETTER_RECEIVE,
    NEWSLETTER_SUBMIT_ERROR,
    NEWSLETTER_SUBMIT_SUBSCRIPTION,
    CLEAR_ERROR,
    NEWSLETTER_SUBMIT_DONE,
} from '../constants';
import { error as errorReducer } from './Error.reducer';

const defaultState = {
    result: {
        email: '',
        isSuccessful: false,
        receivedResponse: false,
        message: '',
    },
    errors: {},
};

export const newsletter = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case NEWSLETTER_RECEIVE:
        case NEWSLETTER_SUBMIT_DONE:
        case CLEAR_ERROR:
            return {
                ...state,
                ...payload,
            };
        case NEWSLETTER_SUBMIT_SUBSCRIPTION:
            return {
                ...state,
                payload: {
                    ...state.payload,
                    ...payload,
                },
            };
        case NEWSLETTER_SUBMIT_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action),
            };
        default:
            return state;
    }
};
